import _slicedToArray from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _taggedTemplateLiteral from "/vercel/path0/node_modules/.pnpm/@babel+runtime@7.15.4/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import { useMemo } from 'react';
import { FillInBlankInput } from './fill-in-blank-input.component';
import styled from '@xstyled/styled-components';
import { getSize } from '@lib/common';
import { jsx as _jsx } from "react/jsx-runtime";
var InlineHTMLSpan = styled.span(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  display: inline;\n  p {\n    display: inline;\n    margin: 0;\n  }\n  img {\n    max-width: 100%;\n    vertical-align: middle;\n  }\n"])));
var StyledFillInBlankDescription = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  color: #1e293b;\n  line-height: ", ";\n  font-weight: 500;\n  p {\n    margin: 0;\n  }\n  img {\n    max-width: 100%;\n  }\n"])), getSize('typo16'), getSize('padding24'));

var parseHTMLWithBlanksAi = function parseHTMLWithBlanksAi(html, beforeQuestion, afterQuestion, changeType, startQuestionIndex) {
  var regex = /<fib-blank\s+[^>]*id="([^"]+)"[^>]*>/g;
  var parts = [];
  var lastIndex = 0;
  var match;
  var keyCounter = 0;
  var blankCounter = startQuestionIndex;

  while ((match = regex.exec(html)) !== null) {
    var _match = match,
        _match2 = _slicedToArray(_match, 2),
        fullMatch = _match2[0],
        uuid = _match2[1];

    var matchIndex = match.index;

    if (matchIndex > lastIndex) {
      var htmlBefore = html.substring(lastIndex, matchIndex);

      if (htmlBefore.trim() || htmlBefore === ' ') {
        parts.push( /*#__PURE__*/_jsx(InlineHTMLSpan, {
          dangerouslySetInnerHTML: {
            __html: htmlBefore
          }
        }, "html-".concat(keyCounter++)));
      }
    } // Get values from before and after questions


    var getFibValue = function getFibValue(q, id) {
      var _q$answers;

      var ans = q === null || q === void 0 ? void 0 : (_q$answers = q.answers) === null || _q$answers === void 0 ? void 0 : _q$answers.find(function (a) {
        return a.id.toString() === id;
      });
      return (ans === null || ans === void 0 ? void 0 : ans.description) || '';
    };

    var afterValue = getFibValue(afterQuestion, uuid);
    var beforeValue = beforeQuestion ? getFibValue(beforeQuestion, uuid) : afterValue;
    parts.push( /*#__PURE__*/_jsx(FillInBlankInput, {
      index: blankCounter++,
      uuid: uuid,
      value: afterValue,
      beforeValue: beforeValue,
      changeType: changeType
    }, uuid));
    lastIndex = matchIndex + fullMatch.length;
  }

  if (lastIndex < html.length) {
    var htmlAfter = html.substring(lastIndex);

    if (htmlAfter.trim() || htmlAfter === ' ') {
      parts.push( /*#__PURE__*/_jsx(InlineHTMLSpan, {
        dangerouslySetInnerHTML: {
          __html: htmlAfter
        }
      }, "html-".concat(keyCounter++)));
    }
  }

  if (parts.length === 0 && html.trim()) {
    parts.push( /*#__PURE__*/_jsx(InlineHTMLSpan, {
      dangerouslySetInnerHTML: {
        __html: html
      }
    }, "html-full"));
  }

  return parts;
};

export var FillInBlankDescription = function FillInBlankDescription(_ref) {
  var description = _ref.description,
      beforeQuestion = _ref.beforeQuestion,
      afterQuestion = _ref.afterQuestion,
      changeType = _ref.changeType,
      startQuestionIndex = _ref.startQuestionIndex;
  var renderedParts = useMemo(function () {
    return parseHTMLWithBlanksAi(description, beforeQuestion, afterQuestion, changeType, startQuestionIndex);
  }, [description, beforeQuestion, afterQuestion, changeType, startQuestionIndex]);
  return /*#__PURE__*/_jsx(StyledFillInBlankDescription, {
    children: renderedParts
  });
};